import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import DebtReliefOfficeWrapper from "@components/layouts/debtReliefOfficeWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function PrivacyPolicyHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <DebtReliefOfficeWrapper>
            <PrivacyPolicy
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </DebtReliefOfficeWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
